<main>
    <form [formGroup]="form">
        <div>
            <p class="title">Selecionar um cliente existente ou criar um novo</p>
            <div class="mt-4 w-full flex align-items-center" style="text-align: left;">
                <span class="p-input-icon-right w-full">
                    <i class="pi pi-search"></i>
                    <input type="text" pInputText class="select-custom-sm  w-full" placeholder="Pesquisar Nome ou Cpf" style="height:34.6px"/>
                </span>
                <span class="option-label-1 ml-4">Adicionar um novo cliente</span>
            </div>
        </div>
        <div class="mt-5 pt-2">
            <p class="title">Selecione quando será sua consulta</p>
            <div class="mt-5 w-full flex align-items-center" style="text-align: left;">
                <span class="p-float-label mr-3">
                    <p-calendar styleClass="w-20rem custom-calendar-input" [showIcon]="true"></p-calendar>
                    <label for="data">Data</label>
                </span>
                <div class="relative">
                    <span style="top: -22px;font-size:12px" class="absolute right-0 option-label-1 ml-4">Especifique hora e minuto</span>
                    <span class="p-float-label">
                        
                        <p-dropdown [ngModelOptions]="{standalone: true}" [(ngModel)]="hora" [options]="['','12:00','13:00','14:00']" placeholder=""  styleClass="w-20rem" inputId="hora"></p-dropdown>
                        <label for="data">Hora</label>
                        
                    </span>
                </div>
                <div class="pl-3 pr-3 flex align-items-center justify-content-center flex-1">
                    <div class="mt-2 mr-2">
                        <p-inputSwitch></p-inputSwitch>
                    </div>
                    <div>Repetir consulta de 14/14 dias</div>
                </div>
            </div>
            <div class="mt-5 pt-3">
                <split-select-button (onOptionClick)="toogleAgendamentosBtn($event)" [options]="optionAgendamentosBtn"></split-select-button>
            </div>
            <div class="mt-5 pt-3 flex flex-grow">
                <div class="flex-1 pr-2">
                    <span class="p-float-label w-full">
                        <p-dropdown  
                            [ngModelOptions]="{standalone: true}"
                            styleClass="w-full"
                            [(ngModel)]="servico"
                            placeholder="" 
                            [options]="[
                                '',
                                'Primeira consulta Coloproctologia'
                            ]"  
                            inputId="servico"></p-dropdown>
                        <label for="data">Serviço</label>
                    </span>
                </div>
                <div class="pr-2">
                    <span class="p-float-label">
                        <p-dropdown [ngModelOptions]="{standalone: true}" [(ngModel)]="tempo" [options]="['','08:30']" placeholder=""  styleClass="w-10rem" inputId="tempo"></p-dropdown>
                        <label for="data">Tempo</label>
                    </span>
                </div>
                <div>
                    <span class="p-float-label">
                        <input pInputText  placeholder=""  class="w-10rem" inputId="valor"/>
                        <label for="data">R$ valor</label>
                    </span>
                </div>
            </div>
            <div class="mt-5">
                <span class="option-label-1">Adicionar outro serviço</span>
            </div>
            <div class="mt-5">
                <p class="title">Lista de espera</p>
            </div>
            <div>
                <p-radioButton formControlName="listaEspera" value="1" label="Somente esse profissional"></p-radioButton>
            </div>
            <div class="mt-3">
                <p-radioButton formControlName="listaEspera" value="2" label="Todos da especialidade"></p-radioButton>
            </div>
            <div class="mt-5">
                <span class="p-float-label w-full">
                    <input pInputText class="w-full" />
                    <label for="data" >Nota</label>
                </span>
            </div>
            <div class="mt-5">
                <p class="title">Marketing autorizações</p>
            </div>
            <div class="mt-3">
                <div class="mt-3">
                    <div class="switch-line">
                        <p-inputSwitch></p-inputSwitch>
                        <span class="label-switch ml-2">Disparo de confirmaçãoes e cancelamentos de consultas</span>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="switch-line">
                        <p-inputSwitch></p-inputSwitch>
                        <span class="label-switch ml-2">Lembrete do agendamento</span>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="switch-line">
                        <p-inputSwitch></p-inputSwitch>
                        <span class="label-switch ml-2">Pré-Confirmação</span>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="switch-line">
                        <p-inputSwitch></p-inputSwitch>
                        <span class="label-switch ml-2">Avaliações</span>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="switch-line">
                        <p-inputSwitch></p-inputSwitch>
                        <span class="label-switch ml-2">Campanhas Marketing</span>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="footer">
        <button (click)="cancelar()" pRipple pButton class="p-button-outlined p-button-secondary flex justify-content-center ">
            CANCELAR
        </button>
        <button (click)="salvar()" pRipple pButton class="flex justify-content-center">
            CRIAR CONSULTA
        </button>
    </div>
</main>